export const generateSendSmsLink = (phones) => {
  const phonesStr = phones
    .map(encodeURIComponent)
    .join(',');

  return `/crm/sms/send?phones=${phonesStr}`;
};



// WEBPACK FOOTER //
// ./src/utils/generate-send-sms-link.js